import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRouter from "./PrivateRouter";
import PublicRouter from "./PublicRouter";
import AdminRouter from "./AdminRouter";
import PublicLayout from "../Partials/PublicLayout";
import Register from "../Auth/register";
import VerifyOtp from "../Auth/verifyotp";
import Select from "../Domain/select";
import InterviewStart from "../Interview/start";
import QuestionPaper from "../Interview/question";
import Result from "../Interview/result";
import AdminLogin from "../Admin/login";
import Candidates from "../Admin/candidates";
import Candidatesview from "../Admin/candidateview";
import Leaderboard from "../Admin/leaderboard";
import CreateQuestion from "../Question/create";
import DeleteQuestion from "../Question/delete";
import UpdateQuestion from "../Question/update";
import ListQuestion from "../Question/list";

const Routers = () => {
  return (
    <BrowserRouter>
      <Routes>

        {/* Global Layout With Header */}
        <Route element={<PublicLayout />}>

          {/* Public Routes */}
          <Route element={<PublicRouter />}>
            <Route path="/register" element={<Register />} />
            <Route path="/verify-otp" element={<VerifyOtp />} />
            <Route path="/select" element={<Select />} />
            <Route path="/start" element={<InterviewStart />} />
            <Route path="/question" element={<QuestionPaper />} />
            <Route path="/result" element={<Result />} />
          </Route>

          {/* Private Routes */}
          <Route element={<PrivateRouter />}>
            <Route path="/" element={<div>Dashboard Page 🚀</div>} />
          </Route>

           {/* ✅ Admin Login (PUBLIC) */}
          <Route path="/admin-login" element={<AdminLogin />} />

          <Route element={<AdminRouter />}>
            <Route path="/admin-candidates" element={<Candidates />} />
            <Route path="/admin-view/:id" element={<Candidatesview />} />
            <Route path="/admin-leaderboard" element={<Leaderboard />} />
            <Route path="/admin-create" element={<CreateQuestion/>} />
            <Route path="/admin-delete" element={<DeleteQuestion/>} />
            <Route path="/admin-update" element={<UpdateQuestion/>} />
            <Route path="/admin-list" element={<ListQuestion/>} />
          </Route>
        </Route>

      </Routes>
    </BrowserRouter>
  );
};

export default Routers;